module.exports = __webpack_public_path__ + "img/logo.1151dc61.png";